(function (angular, schoolwork12) {

    'use strict';
    angular.module(schoolwork12.app.student.name)

    .factory(schoolwork12.app.student.services.studentRemovePersonalGroup,
        ['$rootScope', '$http', '$uibModal', schoolwork12.app.auth.services.authentication,
        function($rootScope, $http, $uibModal, authentication) {

  		var service  = function removePersonalGroupModal(selectedStudents, selectedStudentsCount) {
			var modalInstance = $uibModal.open({
			    templateUrl: schoolwork12.app.student.templates.studentRemovePersonalGroup,
			    size: 'lg',
			    backdrop: 'static',
			    controller: ['$scope', '$uibModalInstance',
		        function ($scope, $uibModalInstance) {
		       		console.log("Viewing a list of the personal groups of selected students");

			    //initialize default settings
				$scope.isRemovePersonalGroupBusy = false;
			    $scope.displayPersonalGroupGrid = false;
			    $scope.studentsCount = selectedStudentsCount;
			    $scope.closeClick = false;

				String.prototype.format = function(str) {
					var args = arguments;
					return this.replace(/{(\d+)}/g, function(match, number) {
					return typeof args[number] != 'undefined'
						? args[number]
						: match
					;
					});
				};

				var resetFlags = function() {
					$scope.personalGroupErrorOccurred = false;
					$scope.closeClick = false;
                    $rootScope.actionCompletedSuccessfully = false;
	            	$rootScope.actionCompletedSuccessfullyMessage = "";
                }

				// enable flag to close the notifications
				$scope.closeNotification = function() {
					$scope.closeClick = true;
	            }

			    $scope.gridOptions = {
			     	enableFiltering : true,
					enableRowSelection : true,
					enableRowHeaderSelection : true,
					showGridFooter : true,
					multiSelect: false,
					enableCellEditOnFocus : true,
					rowHeight: 50
			    };

			    //enable Remove button only if any row is selected
			    $scope.gridOptions.onRegisterApi = function (gridApi) {
	                $scope.gridApi = gridApi;
			    	$scope.gridApi.selection.on.rowSelectionChanged($scope,function(row){
			    		$scope.rowSelected =  row.isSelected;
			    		$scope.currentGroup = row.entity;
			    	});
            	};

            	//build column definitions
				$scope.gridOptions.columnDefs = [
				    { field: 'name', displayName: 'Group Name', width: '33%'},
				    { field: 'description', displayName: 'Details'},
				];

				// Get all the studentsIds in an array
				var selectedStudentsIds = [];
				for (var i = 0; i < selectedStudents.length; i++) {
					selectedStudentsIds.push(selectedStudents[i].idnId);
				};

				//on click of Display, get available personal groups for students selected
			    $scope.getAvailableGroups = function(){
			    	resetFlags();
					$http({
							url : schoolwork12.app.student.endpoints.personalGroupUrl + "search",
							method : "POST",
							data : {
										"method": "searchGroups",
										"parameters": [
											{
												"groupName": "",
												"memberInformation": {
                          "owner": authentication.getCurrentUser().identityid,
                        },
												"clientContext": {
													"namespace": "IDENTITY_MANAGEMENT_SERVICE",
													"version": "1",
													"clientIPAddress": "1.1.1.1"
												}
											}
										]
									},
							headers : {
										'X-API-TOKEN' : authentication.getCurrentUser().keycode,
									}
							}).success(function (response) {
								console.info("Viewing Personal Groups details grid");
								if (response.length > 0) {
									$scope.isRemovePersonalGroupBusy = false;
									$scope.displayPersonalGroupGrid = true;
									$scope.gridOptions.data = response;
								} else {
									$scope.personalGroupErrorOccurred = true;
									$scope.personalGroupErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
								}
							}).error(function(error){
								console.info('Error in viewing personal groups grid....'.concat(angular.toJson(error)));
								$scope.personalGroupErrorOccurred = true;
								if (error != null && error.status == 400) {
									for ( var j = 0; j < error.data._errors.length; j++) {
										$scope.personalGroupErrorMesg = $scope.personalGroupErrorMesg + error.data._errors[j] + "\n";
									}
								} else if (error != null && (error.status == 401 || error.status == 403)) {
									$scope.personalGroupErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
								} else {
									$scope.personalGroupErrorMesg = schoolwork12.app.errorMessages.internalError;
								}
						});
			    	};

			    	//on click of Remove, remove students from PersonalGroup
			    	$scope.removeStudentsToPersonalGroup = function () {
					    	var group = $scope.currentGroup;
							$scope.isRemovePersonalGroupBusy = true;
							resetFlags();
							console.log("Trying to remove {0} students from the group {1}".format(selectedStudentsCount, group.name));

							//remove the selected personal group for selected students
			             	$http({
				              	url : schoolwork12.app.student.endpoints.personalGroupUrl + group.groupID + '/students',
				              	method : "PUT",
				              	data : {
										"method": "update",
										"idntSchInfo": selectedStudents,
										"parameters": [
											{
												"group": {
													"access": group.access,
													"groupType": group.groupType,
													"name": group.name,
													"groupStatus": group.groupStatus,
													"description": group.description
												},
												"memberModifications": {
													"submittedByIdentityID": authentication.getCurrentUser().identityid,
													"owner": group.owner.identityID
												},
												"clientContext": {
													"namespace": "IDENTITY_MANAGEMENT_SERVICE",
													"clientIPAddress": "1.1.1.1"
												}
											}
										]
										},
			        		  	headers : {
											'X-API-TOKEN' : authentication.getCurrentUser().keycode,
										}
				              	}).then(
									function (response) {
										console.info("Students removed from PersonalGroup successfully. Server response: ", response.data);
										$scope.personalGroupErrorOccurred = false;
										$rootScope.actionCompletedSuccessfully = true;
			            	   			$rootScope.actionCompletedSuccessfullyMessage = response.data;
										$uibModalInstance.close();
									},
									function(error){
										$scope.personalGroupErrorMesg = '';
										console.info('Error removing students from a personal group....'.concat(angular.toJson(error)));
										$scope.personalGroupErrorOccurred = true;

										if (error != null && error.status == 400) {
											for ( var j = 0; j < error.data._errors.length; j++) {
												$scope.personalGroupErrorMesg = $scope.personalGroupErrorMesg + error.data._errors[j] + "\n";
											}
										} else if (error != null && (error.status == 401 || error.status == 403)) {
											$scope.personalGroupErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
										} else {
											$scope.personalGroupErrorMesg = schoolwork12.app.errorMessages.internalError;
										}
								})['finally']
								(function () {
									// Stop spinning cog.
									// Indicates search is
									// complete.
									$scope.isRemovePersonalGroupBusy = false;
								});
					};
					// retrieve groups
					$scope.getAvailableGroups();

				$scope.cancel = function () {
				    $uibModalInstance.dismiss('cancel');
				};
			}],

		});

	};

    return {
    	service: service
    };

}]);

}(angular, schoolwork12));
